<template>
  <div id="reservation">
    <!-- ページの内容 -->

    <div class="container">
      <div class="row">
        <div class="col-lg-8 offset-lg-2 bg-white pb-3">
          <div class="stepContent" id="stepContent">
            <step-component :steps="steps"></step-component>

            <page-name :step="step" :pageTitle="pageTitle"></page-name>
            <transition name="component-fade" mode="out-in">
              <component
                :session_start_date="session_start_date"
                :dead_lines="dead_lines"
                :isItemsLoading="isItemsLoading"
                :is="currentPage"
                wait-for="data-loaded"
                :shops="shops"
                :reserveShops="reserveShops"
                :items="items"
                :radioResult="radioResult"
                :selectablePaymentMethod="selectablePaymentMethod"
                :weeks="weeks"
                :calData="calData"
                :reservation="reservation"
                :seenCart="seenCart"
                :seenCartContents="seenCartContents"
                :category="category"
                :seenItemList="seenItemList"
                :readyCheckout="readyCheckout"
                :publishableKey="publishableKey"
                @next="next"
                @prev="prev"
                @selectCat="selectCat"
                @selectAll="selectAll"
                @showCart="showCart"
                @hideCart="hideCart"
                @showCartContents="showCartContents"
                @showItemList="showItemList"
                @readMore="readMore"
                @checkSeen="checkSeen"
                @returnAppSum="returnAppSum"
                @createCheckoutUI="createCheckoutUI"
                @hideCheckoutModal="hideCheckoutModal"
                @showCheckoutModal="showCheckoutModal"
                @smoothScroll="smoothScroll"
                @setRadioResult="setRadioResult"
              ></component>
            </transition>

            <blue-button
              @click="
                radioJudg()
                next()
                today()
              "
              :buttonText="buttonText"
              :step="step"
              :items="items"
              :radioResult="radioResult"
              v-if="seen"
              v-show="!isItemsLoading"
              @readMore="readMore"
              id="blueBtn"
            ></blue-button>
            <div class="next-btn-loading" v-show="isItemsLoading">
              <p>読み込み中です...</p>
            </div>

            <p @click="prev(1)" class="prev" v-if="prevSeen">
              <span>
                <i class="fas fa-chevron-left"></i>
                日時選択へもどる
              </span>
            </p>

            <p v-if="prevSeen" class="text-center mt-4">
              <small>
                ※ 日数によって選べる商品が変わります。
                <br />
                ご希望の商品が見当たらない場合は、日付を変更してお試し頂くか、 お電話にてお問い合わせください。
              </small>
            </p>

            <router-link to="/" class="topLink" v-if="topSeen">
              <span>
                <i class="fas fa-chevron-left"></i>
                トップへ戻る
              </span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- <button class="hidden_" @click="sendMail">send</button> -->
  </div>
</template>

<script>
import $ from 'jquery'
import axios from 'axios'
import stepComponent from '../components/stepComponent.vue'
import pageName from '../components/pageName.vue'
import blueButton from '../components/blueButton.vue'
import step1 from '../components/step1.vue'
import step2 from '../components/step2.vue'
import step3 from '../components/step3.vue'
import step4 from '../components/step4.vue'
import step5 from '../components/step5.vue'
import step6 from '../components/step6.vue'
import { loadStripe } from '@stripe/stripe-js'
import 'url-search-params-polyfill'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'

dayjs.extend(isBetween)

export default {
  components: {
    'step-component': stepComponent,
    'page-name': pageName,
    'blue-button': blueButton,
    step1: step1,
    step2: step2,
    step3: step3,
    step4: step4,
    step5: step5,
    step6: step6
  },
  name: 'reservation',
  props: ['AppSum'],
  head: {
    title: {
      inner: '予約ページ',
      separator: '|',
      complement: '銀のすぷーん予約サイト'
    },
    script: [
      {
        type: 'text/javascript',
        src: 'https://ajaxzip3.github.io/ajaxzip3.js'
      },
      {
        type: 'text/javascript',
        src: 'https://cdnjs.cloudflare.com/ajax/libs/libphonenumber-js/1.1.10/libphonenumber-js.min.js'
      }
    ]
  },
  computed: {
    selectablePaymentMethod: function() {
      // 選択した店舗の全ての決済方法を取得
      return this.reserveShops.filter(shop => shop.title.rendered === this.radioResult)[0]?.acf.payment_method
    },
    selectedShopQrEnabled: function() {
      return this.reserveShops.filter(shop => shop.title.rendered === this.radioResult)[0]?.acf?.qr
    }
  },
  data() {
    return {
      // itemsのローディングフラグ
      isItemsLoading: true,
      // blueButtonの表示フラグ
      seen: true,
      prevSeen: false,
      topSeen: true,
      // カートの表示の表示フラグ
      seenCart: false,
      // カートのコンテンツの表示フラグ
      seenCartContents: false,
      // 商品リストの表示フラグ
      seenItemList: false,
      // カレンダー
      weeks: {
        1: '日',
        2: '月',
        3: '火',
        4: '水',
        5: '木',
        6: '金',
        7: '土'
      },
      calData: {
        year: '',
        month: '',
        date: ''
      },
      // 予約情報
      radioResult: '',
      reservation: {
        month: '',
        date: '',
        year: '',
        dayOfWeek: '',
        time1: '',
        time2: '',
        store: '',
        leadTime: 0,
        saitan: 1,
        item: {
          name: '',
          price: '',
          number: '',
          images: {
            main: '',
            thum: {},
            reserMain: ''
          },
          candle: {
            big: '',
            small: ''
          },
          message: '',
          cat: '',
          id: '',
          desc: '',
          kikaku: [],
          original: '',
          reserId: ''
        },
        count: 0,
        hiddenSum: 0,
        tax: 0,
        sum: 0,
        cart: [],
        totalCartItemNumber: 0,
        checkbox: '',
        flag1: false,
        flag2: false,
        customer: {
          name1: '',
          name3: '',
          sei: '',
          mei: '',
          name2: '',
          name4: '',
          kanasei: '',
          kanamei: '',
          tel: '',
          email: '',
          contactTime: '10:00~12:00',
          dm: '',
          payment_method: '',
          add1: '',
          add2: '',
          add3: '',
          add4: '',
          comment: ''
        },
        itemList: [],
        showItemList: [],
        nonce: ''
      },
      // ステップの情報
      currentPage: 'step1',
      step: 1,
      pageTitle: ['受け取り店舗をえらぶ', '受取日時をえらぶ', '商品をえらぶ', 'お客様情報を入力', '確認・決済', '完了'],
      buttonText: [
        //        'ご注文へすすむ',
        '受取日時指定へ進む',
        '商品選択へすすむ',
        'もっとみる',
        '確認・決済画面へすすむ',
        'この内容で予約する',
        'トップページへ戻る'
      ],
      steps: [
        {
          number: 1,
          stepName: '店舗選択',
          current: true,
          visited: false
        },
        {
          number: 2,
          stepName: '受取日時',
          current: false,
          visited: false
        },
        {
          number: 3,
          stepName: '商品選択',
          current: false,
          visited: false
        },
        {
          number: 4,
          stepName: 'お客様情報',
          current: false,
          visited: false
        },
        {
          number: 5,
          stepName: '確認・決済',
          current: false,
          visited: false
        },
        {
          number: 6,
          stepName: '完了',
          current: false,
          visited: false
        }
      ],
      reserveShops: [],
      shops: [],
      items: [],
      category: [],
      // 検索の数
      numberSearch: 999,
      searchCat: 'ホールケーキ',
      url: window.location.origin.includes('reserve.g-spoon.co.jp')
        ? 'https://reserve.g-spoon.co.jp/cms' //(店舗情報) 営業時間を消したい
        : 'https://reserve.g-spoon.addapter.jp/cms',
      official_url: 'https://g-spoon.co.jp', //(営業時間)　 営業時間だけにしたい
      sumForApp: this.AppSum,
      reservationNum: '',
      readyCheckout: false,
      publishableKey: window.location.origin.includes('reserve.g-spoon.co.jp')
        ? process.env.VUE_APP_PROD_STRIPE_PUBLIC_KEY
        : process.env.VUE_APP_TEST_STRIPE_PUBLIC_KEY,
      checkoutSession: null,
      dead_lines: [],
      session_start_date: dayjs()
    }
  },
  mounted() {
    // 予約サイトからの店舗情報 (決済方法の情報を取得したいため)
    axios
      .get(this.url + '/wp-json/wp/v2/shop?orderby=date&order=desc')
      .then(response => (this.reserveShops = response.data))
      .catch(e => {
        console.log(e)
      }),
      // 店舗 (営業時間の情報を取得したいため)
      axios
        .get(this.official_url + '/wp-json/wp/v2/business_hours?orderby=date&order=desc')
        .then(response => (this.shops = response.data))
        .catch(e => {
          console.log(e)
        })
    // 商品
    axios
      .get(this.url + '/wp-json/wp/v2/item?_embed&per_page=999&orderby=date&order=desc')
      .then(response => {
        this.items = response.data
        this.isItemsLoading = false
      })
      .catch(e => {
        console.log(e)
      })
    // 商品カテゴリー
    axios
      .get(this.url + '/wp-json/wp/v2/item_cat')
      .then(response => {
        const sortableData = response.data.map(cat => {
          const name = cat.name || ''
          if (name === 'ホールケーキ') {
            return { ...cat, orderId: 1 }
          } else if (name === 'カットケーキ') {
            return { ...cat, orderId: 2 }
          } else if (name === 'シュー・プリン・ロール') {
            return { ...cat, orderId: 3 }
          } else if (name === '焼菓子') {
            return { ...cat, orderId: 4 }
          } else if (name === 'チョコレート') {
            return { ...cat, orderId: 5 }
          } else if (name === 'ラッピング') {
            return { ...cat, orderId: 6 }
          } else if (name === 'お供えラッピング') {
            return { ...cat, orderId: 7 }
          } else if (name === 'その他') {
            return { ...cat, orderId: 10 }
          } else if (name === 'ナンバーキャンドル') {
            return { ...cat, orderId: 9 }
          } else {
            return { ...cat, orderId: 10 }
          }
        })

        this.category = sortableData.filter(cat => cat.name !== 'チョコレート').sort((a, b) => a.orderId - b.orderId)
      })
      .catch(e => {
        console.log(e)
      })

    axios
      .get(this.url + '/return_reservation_num.php')
      .then(
        response => (
          // reservationNumber
          (this.reservationNum = response.data.receptionNumber), (this.reservation.nonce = response.data.nonce)
        )
      )
      .catch(e => {
        console.log(e)
      })
  },
  methods: {
    setRadioResult: function(shopName) {
      this.radioResult = shopName
    },
    hideCheckoutModal() {
      // セッションを破棄して、決済モーダルを非表示 (stripe)
      if (this.checkoutSession) {
        // this.checkoutSession.unmount()
        this.checkoutSession.destroy()
      }
      this.checkoutSession = null
      this.readyCheckout = false
      this.smoothScroll()
    },
    showCheckoutModal() {
      // 決済モーダルを表示

      this.readyCheckout = true
    },
    // 決済
    async createCheckoutUI() {
      if (!this.reservation.customer.payment_method) {
        alert('決済方法を選択してください')
        return
      }

      // セッションを作成する  (stripe)
      const stripe = await loadStripe(this.publishableKey)

      const handleComplete = async () => {
        // 決済完了後にメール送信
        console.log('checkout complete')
        this.checkoutSession.destroy()

        this.sendMail()
        if (this.radioResult !== '') {
          this.steps[this.step - 1].visited = true
          this.step++
          this.steps[this.step - 1].visited = false
          this.steps[this.step - 1].current = true
          this.currentPage = 'step' + this.step
          this.seen = false
        } else {
          this.seen = true
        }
        this.prevCheck()
        this.topCheck()
        this.$forceUpdate()
        this.smoothScroll()
        return
      }

      const candleTotalPrice = this.reservation.cart.reduce((acc, cur) => {
        if (cur.cat === 'ナンバーキャンドル') {
          return acc + Number(cur.number) * Number(cur.price)
        } else return acc
      }, 0)

      // 合計（税込）を計算
      const totalSum = Math.trunc(this.reservation.sum - candleTotalPrice)
      const candleOnlySum = Math.trunc(candleTotalPrice)

      const form = new FormData()
      form.append('unit_amount', totalSum) // ナンバーキャンドル以外の合計金額
      form.append('candle_amount', candleOnlySum)
      form.append('customer_email', this.reservation.customer.email)

      // カート内情報
      form.append('cartNumber', this.reservation.count) // カード内の商品数

      for (let i = 0; i < this.reservation.count; i++) {
        form.append('cartName' + i, this.reservation.cart[i].name)
        form.append('cartPrice' + i, this.reservation.cart[i].price)
        form.append('cartNumber' + i, this.reservation.cart[i].number)
        form.append('cartCandle_big' + i, this.reservation.cart[i].candle.big)
        form.append('cartCandle_small' + i, this.reservation.cart[i].candle.small)
        form.append('cartMsg' + i, this.reservation.cart[i].message)
        form.append('cartCat' + i, this.reservation.cart[i].cat)
      }

      // clientSecretを取得

      const data = await fetch(this.url + '/checkout.php', {
        method: 'POST',
        body: form
      }).then(response => response.json())

      const checkout = await stripe.initEmbeddedCheckout({
        onComplete: handleComplete,
        clientSecret: data.client_secret
      })

      checkout.mount('#checkout') // セッションをdomにマウントする
      this.checkoutSession = checkout
    },
    // スムーススクロール
    smoothScroll: function() {
      let speed = 1000
      let target = $('#stepContent')
      let position = target.offset().top
      $('html, body').animate({ scrollTop: position }, speed, 'swing')
      return false
    },
    sendMail: function() {
      const params = new URLSearchParams()
      // 受取り日時
      params.append('qr', this.selectedShopQrEnabled ? 'qr' : 'no_qr')
      params.append('store', this.reservation.store.title.rendered)
      params.append('month', this.reservation.month)
      params.append('date', this.reservation.date)
      params.append('time1', this.reservation.time1)
      params.append('time2', this.reservation.time2)
      // お客様情報
      params.append('name1', this.reservation.customer.name1)
      params.append('name2', this.reservation.customer.name2)
      params.append('tel', this.reservation.customer.tel)
      params.append('email', this.reservation.customer.email)
      params.append('contactTime', this.reservation.customer.contactTime)
      params.append('dm', this.reservation.customer.dm)
      params.append('payment_method', this.reservation.customer.payment_method)
      params.append('add1', this.reservation.customer.add1)
      params.append('add2', this.reservation.customer.add2)
      params.append('add3', this.reservation.customer.add3)
      params.append('add4', this.reservation.customer.add4)
      params.append('comment', this.reservation.customer.comment)
      params.append('checkBox', this.reservation.customer.checkBox)
      // カート内情報
      params.append('cartNumber', this.reservation.count)
      params.append('cart', this.reservation.cart)
      for (let i = 0; i < this.reservation.count; i++) {
        params.append('cartName' + i, this.reservation.cart[i].name)
        params.append('cartPrice' + i, this.reservation.cart[i].price)
        params.append('cartNumber' + i, this.reservation.cart[i].number)
        params.append('cartCandle_big' + i, this.reservation.cart[i].candle.big)
        params.append('cartCandle_small' + i, this.reservation.cart[i].candle.small)
        params.append(
          'cartMsg' + i,
          this.reservation.cart[i].original == 'カットケーキ用メッセージカード'
            ? this.reservation.cart[i].cut_cake_message
            : this.reservation.cart[i].message
        )
        params.append('cartMsg2' + i, this.reservation.cart[i].message_2)
        params.append('cartCat' + i, this.reservation.cart[i].cat)
      }

      // カート内にあるナンバーキャンドルの合計金額を計算
      const candleTotalPrice = this.reservation.cart.reduce((acc, cur) => {
        if (cur.cat === 'ナンバーキャンドル') {
          return acc + Number(cur.number) * Number(cur.price)
        } else return acc
      }, 0)

      // 税の合計
      const taxPrice = Math.trunc((this.reservation.sum - candleTotalPrice) * 0.08) + Math.trunc(candleTotalPrice * 0.1)

      // 合計金額
      params.append('sum', this.reservation.sum)
      params.append('tax', taxPrice)
      params.append('nonce', this.reservation.nonce)

      ////////////////////////// メール送信処理　本番用 //////////////////////////
      if (window.location.origin.includes('reserve.g-spoon.co.jp')) {
        axios
          .post(this.url + '/send_mail.php', params)
          .then(response => {
            let gaItem = []
            let taxPrice =
              Math.trunc((this.reservation.sum - candleTotalPrice) * 1.08) + Math.trunc(candleTotalPrice * 1.1)

            for (let j = 0; j < this.reservation.count; j++) {
              gaItem.push({
                id: this.reservation.cart[j].reserId,
                name: this.reservation.cart[j].name,
                quantity: this.reservation.cart[j].number,
                price: this.reservation.cart[j].price
              })
            }
            gtag('event', 'purchase', {
              transaction_id: this.reservationNum,
              affiliation: '銀のすぷーん予約サイト',
              value: this.reservation.sum,
              currency: 'JPY',
              tax: taxPrice,
              items: gaItem
            })
          })
          .catch(err => {
            console.debug(err)
            alert('システムエラーが発生しました。詳しくは管理者へお問い合わせ下さい。')
          })
      } else {
        ////////////////////////// メール送信処理　テスト用 //////////////////////////
        axios
          .post(this.url + '/test_send.php', params)
          .then(response => {})
          .catch(err => {
            console.debug(err)
            alert('システムエラーが発生しました。詳しくは管理者へお問い合わせ下さい。')
          })
      }
    },
    // ステップを次に進める処理
    next: function() {
      if (this.step === 6) {
        return
      }

      if (this.step === 5 && this.reservation.customer.payment_method == '店舗決済') {
        this.sendMail()
        /////////////////////////////////////////////////////////////////////////////
        if (this.radioResult !== '') {
          this.steps[this.step - 1].visited = true
          this.step++
          this.steps[this.step - 1].visited = false
          this.steps[this.step - 1].current = true
          this.currentPage = 'step' + this.step
          this.seen = false
        } else {
          this.seen = true
        }
        this.prevCheck()
        this.topCheck()
        this.$forceUpdate()
        this.smoothScroll()
        return
      }
      if (this.step === 4 && this.reservation.flag1 === false) {
        alert('「個人情報保護方針、特定商取引に基づく表記に同意する」にチェックしてください。')
        return
      } else if (this.step === 4 && this.reservation.flag1 === true) {
        this.customer()
        if (this.reservation.flag2 === false) {
          return
        }

        if (!this.reservation.customer.payment_method) {
          alert('決済方法を選択してください')
          return
        }
      }
      if (this.step === 2) {
        let time1 = document.getElementsByName('time1')
        this.reservation.time1 = time1[0].value
        let time2 = document.getElementsByName('time2')
        this.reservation.time2 = time2[0].value

        this.session_start_date = dayjs()
      }
      if (this.radioResult !== '') {
        this.steps[this.step - 1].visited = true
        this.step++
        this.steps[this.step - 1].visited = false
        this.steps[this.step - 1].current = true
        this.currentPage = 'step' + this.step
        this.seen = false
      } else {
        this.seen = true
      }
      this.prevCheck()
      this.topCheck()
      this.$forceUpdate()
      this.smoothScroll()
    },
    // ステップを前に戻す処理
    prev: function(number) {
      if (this.step === 2 || this.step === 1) {
        // this.radioResult = ''
        this.reservation.cart = []
        this.seenCart = false
        this.reservation.hiddenSum = 0
        this.reservation.tax = 0
        this.reservation.sum = 0
        this.reservation.count = 0
        this.reservation.showItemList = []
        this.reservation.itemList = []
        this.reservation.totalCartItemNumber = 0
      } else {
        if (this.step === 3) {
          this.reservation.cart = []
          this.seenCart = false
          this.reservation.hiddenSum = 0
          this.reservation.tax = 0
          this.reservation.sum = 0
          this.reservation.count = 0
          this.reservation.showItemList = []
          this.reservation.itemList = []
          this.reservation.totalCartItemNumber = 0
          const pageHeaderCartBtn = document.getElementById('pageHeaderCartBtn')
          pageHeaderCartBtn.style.display = 'none'
        }
      }
      if (this.step === 5) {
        this.reservation.flag1 = false
      }
      this.steps[this.step - 1].visited = false
      this.steps[this.step - 1].current = false
      this.step -= number
      this.steps[this.step - 1].visited = false
      this.steps[this.step - 1].current = true
      this.currentPage = 'step' + this.step
      if (this.step === 2 || this.step === 4) {
        this.seen = false
      } else {
        this.seen = true
      }
      this.prevCheck()
      this.topCheck()
      this.$forceUpdate()
      this.smoothScroll()
    },
    prevCheck: function() {
      if (this.step === 3) {
        this.prevSeen = true
      } else {
        this.prevSeen = false
      }
    },
    topCheck: function() {
      if (this.step !== 1) {
        this.topSeen = false
      }
    },
    // 受け取り店舗でのラジオボタン処理
    radioJudg: function() {
      let radios = document.getElementsByName('shopName')
      for (let i = 0; i < radios.length; i++) {
        if (radios[i].checked) {
          // 選択されたラジオボタンのvalue値を取得する
          this.radioResult = radios[i].value
          break
        }
      }
    },
    // カレンダーをクリックした際のモーダル表示
    pushDate: function() {
      let dateBlock = ducument.getElementById(aaa)
      date.Block.style.display = 'block'
    },
    // 現在の日付取得
    today: function() {
      let today = new Date()
      this.calData.year = today.getFullYear()
      this.calData.month = today.getMonth() + 1
      this.calData.date = today.getDate()
    },
    // 表示する商品のリスト（配列）作成
    showItemList: function() {
      // 現在の時刻(販売期間の判定のために使用)
      let today = new Date()
      let todayYear = today.getFullYear()
      let todayMonth = today.getMonth() + 1
      let todayDay = today.getDate()
      let todayLastDate = new Date(todayYear, todayMonth, 0).getDate()
      let nextMonthLastDate = new Date(todayYear, todayMonth + 1, 0).getDate()
      let currentHour = today.getHours()
      let current_min = today.getMinutes()
      // 予約日
      let reservationDate = this.reservation.year + '/' + this.reservation.month + '/' + this.reservation.date

      let reservationDateDt = new Date(reservationDate)
      // 予約日までの日数
      if (this.reservation.month === todayMonth && this.reservation.year === todayYear) {
        this.reservation.leadTime = parseInt(this.reservation.date, 10) - todayDay
      } else if (this.reservation.month === todayMonth + 1) {
        this.reservation.leadTime = parseInt(this.reservation.date, 10) + todayLastDate - todayDay
      } else {
        this.reservation.leadTime = parseInt(this.reservation.date, 10) + todayLastDate + nextMonthLastDate - todayDay
      }
      // 予約のための変数
      let dif
      let reserDate
      let dayWeek = today.getDay() + 1 // 今日の曜日
      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      //this.items(全アイテムをfor　(let i = 0)で回す)
      for (let i = 0; i < this.items.length; i++) {
        const slice = this.items[i].acf.deadline_time
        if (slice !== '') {
          this.dead_lines.push(slice)
          this.dead_lines = [...new Set(this.dead_lines)]
        }

        this.dead_lines.filter(v => v !== '')

        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        // 当日締め切り時間
        let deadLineHour = this.items[i].acf.deadline_time.slice(0, 2)
        let deadLineMin = this.items[i].acf.deadline_time.substr(2, 2)
        // 販売開始日
        let startDate = this.items[i].acf.sales_start_date
        let startDateDt = new Date(startDate)
        // 販売終了日
        let endDate = this.items[i].acf.sales_end_date
        let endDate_dt = new Date(endDate)
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        // 販売開始日と終了日の判定
        if (startDateDt.getTime() > reservationDateDt.getTime() || endDate_dt.getTime() < reservationDateDt.getTime()) {
          // console.log('結果：販売期間外です。')
          // [i]の商品をスキップ
          continue
        }
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        // 製造可能かどうか？
        let seizouFlag = false
        for (let j = 0; j < this.items[i].acf['製造可能店舗'].length; j++) {
          if (this.items[i].acf['製造可能店舗'][j].post_title === this.radioResult) {
            seizouFlag = true
          }
        }
        // まずは最小のリードタイムの商品がthis.reservation.itemListに入るかどうか？
        let itemLeadTime = parseInt(this.items[i].acf.kikaku[0]?.kikaku_leadtime)
        for (let j = 0; j < this.items[i].acf.kikaku.length; j++) {
          // 最小のリードタイムを計算(規画の中に複数リードタイムがあるため)
          if (itemLeadTime > parseInt(this.items[i].acf.kikaku[j]?.kikaku_leadtime)) {
            itemLeadTime = parseInt(this.items[i].acf.kikaku[j]?.kikaku_leadtime)
          }
        }
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        // 当日受付かどうか？
        let todayFlag = true
        if (parseInt(deadLineHour) < parseInt(currentHour)) {
          itemLeadTime++
          todayFlag = false
          // this.reservation.leadTime = this.reservation.leadTime--
          // console.log('当日受付ではないのでリードタイムに+1します。（時間）')
        } else if (
          parseInt(currentHour) === parseInt(deadLineHour) &&
          parseInt(deadLineMin, 10) < parseInt(current_min, 10)
        ) {
          // this.reservation.leadTime = this.reservation.leadTime--
          itemLeadTime++
          todayFlag = false
          // console.log('当日受付ではないのでリードタイムに+1します。（分）')
        }
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        if (seizouFlag) {
          // 製造可能な場合
          if (itemLeadTime <= this.reservation.leadTime) {
            this.reservation.itemList.push(this.items[i])
            // console.log('結果：製造可能で受け渡し可能です。')
          } else {
            // console.log('結果：製造可能ですが受け渡しは間に合いません。')
          }
        } else {
          // 製造不可な場合
          let earliestShipping // 最短の発送日までの日数
          let nextWeek = false // 発送日が来週になるかどうか？
          let nextWeek2 = false // 発送日がさ来週になるかどうか？
          // 今週に配送可能かどうか
          for (let j = 0; j < this.reservation.store.acf['week'].length; j++) {
            if (dayWeek < parseInt(this.reservation.store.acf['week'][j], 10)) {
              earliestShipping = parseInt(this.reservation.store.acf['week'][j]) - dayWeek
              if (parseInt(itemLeadTime) < earliestShipping && earliestShipping <= this.reservation.leadTime) {
                //配送可能！
                this.reservation.itemList.push(this.items[i])
                nextWeek = false
                break
              } else {
                nextWeek = true
              }
            } else {
              nextWeek = true
            }
          }
          // 来週を考えないといけない！
          if (nextWeek) {
            for (let j = 0; j < this.reservation.store.acf['week'].length; j++) {
              if (dayWeek < parseInt(this.reservation.store.acf['week'][j], 10)) {
                earliestShipping = parseInt(this.reservation.store.acf['week'][j]) - dayWeek + 7
              } else if (dayWeek > parseInt(this.reservation.store.acf['week'][j], 10)) {
                earliestShipping = 7 - dayWeek + parseInt(this.reservation.store.acf['week'][j])
              } else {
                earliestShipping = 7
              }
              if (parseInt(itemLeadTime) < earliestShipping && earliestShipping <= this.reservation.leadTime) {
                //配送可能！
                this.reservation.itemList.push(this.items[i])
                nextWeek2 = false
                break
              } else {
                nextWeek2 = true
              }
            }
          }
          // さ来週を考えないといけない！
          if (nextWeek2) {
            for (let j = 0; j < this.reservation.store.acf['week'].length; j++) {
              if (dayWeek < parseInt(this.reservation.store.acf['week'][j], 10)) {
                earliestShipping = parseInt(this.reservation.store.acf['week'][j]) - dayWeek + 14
              } else if (dayWeek > parseInt(this.reservation.store.acf['week'][j], 10)) {
                earliestShipping = dayWeek - parseInt(this.reservation.store.acf['week'][j]) + 7
              } else {
                earliestShipping = 14
              }
              if (parseInt(itemLeadTime) < earliestShipping && earliestShipping <= this.reservation.leadTime) {
                //配送可能！
                this.reservation.itemList.push(this.items[i])
                break
              }
            }
          }
        }
      }

      // リストに入った商品チェック
      // this.reservation.itemList.forEach((el) => {
      //   console.log(el.title.rendered);
      // });

      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      // this.reservation.itemListに入れ終わってからの処理
      // 最低金額のセット
      if (this.reservation.itemList.length !== 0) {
        for (let i = 0; i < this.reservation.itemList.length; i++) {
          for (let j = 0; j < this.reservation.itemList[i].acf.kikaku.length; j++) {
            this.reservation.itemList[i].min_price = this.reservation.itemList[i].acf.kikaku[0]?.kikaku_price
            if (
              parseInt(this.reservation.itemList[i].min_price) >
              parseInt(this.reservation.itemList[i].acf.kikaku[j]?.kikaku_price)
            ) {
              this.reservation.itemList[i].min_price = this.reservation.itemList[i].acf.kikaku[j]?.kikaku_price
            }
          }
        }
      }

      /////////////////////////////////////////////////////////////////////////////
      // リードタイムの複数処理 this.items[i].acf.kikaku[j].kikaku_leadtime
      if (this.reservation.itemList.length !== 0) {
        for (let i = 0; i < this.reservation.itemList.length; i++) {
          ///////////////////
          // 製造可能かどうか？
          let seizou_can = false
          for (let j = 0; j < this.reservation.itemList[i].acf['製造可能店舗'].length; j++) {
            if (this.reservation.itemList[i].acf['製造可能店舗'][j].post_title === this.radioResult) {
              seizou_can = true
              break
            }
          }
          ///////////////////
          // 製造可能商品の時
          if (seizou_can) {
            for (let j = 0; j < this.reservation.itemList[i].acf.kikaku.length; j++) {
              // 当日締め切り時間
              let deadLineHour = this.reservation.itemList[i].acf.deadline_time.slice(0, 2)
              let deadLineMin = this.reservation.itemList[i].acf.deadline_time.substr(2, 2)
              // 当日受付かどうか？
              let todayFlag = true
              let itemLeadTime = parseInt(this.reservation.itemList[i].acf.kikaku[j]?.kikaku_leadtime)
              if (parseInt(deadLineHour) < parseInt(currentHour)) {
                itemLeadTime++
                todayFlag = false
              } else if (
                parseInt(currentHour) === parseInt(deadLineHour) &&
                parseInt(deadLineMin, 10) < parseInt(current_min, 10)
              ) {
                itemLeadTime++
                todayFlag = false
              }
              this.reservation.itemList[i].acf.kikaku[j].boolean = false
              // console.log('商品リードタイム')
              // console.log(itemLeadTime)
              // console.log('予約日')
              // console.log(parseInt(this.reservation.leadTime))
              if (parseInt(itemLeadTime) <= parseInt(this.reservation.leadTime)) {
                // console.log('ok')
                this.reservation.itemList[i].acf.kikaku[j].boolean = true
              } else {
                // console.log('ng')
                this.reservation.itemList[i].acf.kikaku[j].boolean = false
              }
            }
          } else {
            // 配送の時
            // 当日締め切り時間
            let deadLineHour = this.reservation.itemList[i].acf.deadline_time.slice(0, 2)
            let deadLineMin = this.reservation.itemList[i].acf.deadline_time.substr(2, 2)
            // 本日の曜日
            let dayOfWeek_today = new Date().getDay() //  曜日(数値)4(木曜日が４)
            // システム上の曜日（数値）
            let dayOfWeekNumberToday = dayOfWeek_today + 1 // 日曜日が１なので＋１する
            // 最短受け取り可能日までの日数
            for (let j = 0; j < this.reservation.itemList[i].acf.kikaku.length; j++) {
              this.reservation.itemList[i].acf.kikaku[j].boolean = false
              //  console.log('大枠のループ開始！！')
              // 当日受付かどうか？
              let todayFlag = true
              let itemLeadTime = parseInt(this.reservation.itemList[i].acf.kikaku[j]?.kikaku_leadtime)
              if (parseInt(deadLineHour) < parseInt(currentHour)) {
                itemLeadTime++
                todayFlag = false
              } else if (
                parseInt(currentHour) === parseInt(deadLineHour) &&
                parseInt(deadLineMin, 10) < parseInt(current_min, 10)
              ) {
                itemLeadTime++
                todayFlag = false
              }
              /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              //itemLeadTime（商品ごとのリードタイム）、予約日（this.reservation.leadTime）、最短配送可能日（earliestShipping）の計算
              //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              let earliestShipping // 最短の発送日までの日数
              let nextWeek = false // 発送日が来週になるかどうか？
              let nextWeek2 = false // 発送日がさ来週になるかどうか？
              // 今週は配送可能か？
              for (let k = 0; k < this.reservation.store.acf['week'].length; k++) {
                if (dayOfWeekNumberToday < parseInt(this.reservation.store.acf['week'][k], 10)) {
                  earliestShipping = parseInt(this.reservation.store.acf['week'][k]) - dayOfWeekNumberToday
                }
                if (itemLeadTime < earliestShipping && earliestShipping <= this.reservation.leadTime) {
                  this.reservation.itemList[i].acf.kikaku[j].boolean = true
                  break
                } else {
                  nextWeek = true
                }
              }
              // 来週を考えないといけない！
              if (nextWeek) {
                for (let k = 0; k < this.reservation.store.acf['week'].length; k++) {
                  if (dayOfWeekNumberToday < parseInt(this.reservation.store.acf['week'][k], 10)) {
                    earliestShipping = parseInt(this.reservation.store.acf['week'][k]) - dayOfWeekNumberToday + 7
                  } else if (dayOfWeekNumberToday > parseInt(this.reservation.store.acf['week'][k], 10)) {
                    earliestShipping = 7 - dayOfWeekNumberToday + parseInt(this.reservation.store.acf['week'][k])
                  } else {
                    earliestShipping = 7
                  }
                  if (parseInt(itemLeadTime) < earliestShipping && earliestShipping <= this.reservation.leadTime) {
                    //配送可能！
                    this.reservation.itemList[i].acf.kikaku[j].boolean = true
                    nextWeek2 = false
                    break
                  } else {
                    nextWeek2 = true
                  }
                }
              }
              // さ来週を考えないといけない！
              if (nextWeek2) {
                // console.log('さ来週を考えないといけない！')
                for (let k = 0; k < this.reservation.store.acf['week'].length; k++) {
                  if (dayOfWeekNumberToday < parseInt(this.reservation.store.acf['week'][k], 10)) {
                    earliestShipping = parseInt(this.reservation.store.acf['week'][k]) - dayOfWeekNumberToday + 14
                  } else if (dayOfWeekNumberToday > parseInt(this.reservation.store.acf['week'][k], 10)) {
                    earliestShipping = dayOfWeekNumberToday - parseInt(this.reservation.store.acf['week'][k]) + 7
                  } else {
                    earliestShipping = 14
                  }
                  if (parseInt(itemLeadTime) < earliestShipping && earliestShipping <= this.reservation.leadTime) {
                    //配送可能！
                    this.reservation.itemList[i].acf.kikaku[j].boolean = true
                    break
                  }
                }
              }
            }
          }
        }
      }

      // showItemListに入れる作業
      if (this.reservation.itemList.length === 0) {
        return
      } else if (this.reservation.itemList.length < this.numberSearch) {
        for (let i = 0; i < this.reservation.itemList.length; i++) {
          if (this.reservation.itemList[i]._embedded['wp:term'][0][0].name == 'ホールケーキ') {
            this.reservation.showItemList.push(this.reservation.itemList[i])
          }
        }
      } else {
        for (let i = 0; i < this.reservation.itemList.length; i++) {
          if (this.reservation.itemList[i]._embedded['wp:term'][0][0].name == 'ホールケーキ') {
            this.reservation.showItemList.push(this.reservation.itemList[i])
          }
          //            if (this.reservation.showItemList.length >= 15) {
          //              break
          //            }
        }
      }
    },
    // カテゴリー検索（全選択）
    selectAll: function() {
      this.numberSearch = 999
      this.searchCat = ''
      let buttonCat = document.getElementsByClassName('category')
      let buttonAll = document.getElementById('catAll')
      for (let i = 0; i < buttonCat.length; i++) {
        buttonCat[i].classList.remove('active')
      }
      buttonAll.classList.add('active')
      this.reservation.showItemList = []
      for (let i = 0; i < this.numberSearch; i++) {
        if (!this.reservation.itemList[i]) {
          this.seen = false
          return
        } else {
          this.seen = true
          this.reservation.showItemList.push(this.reservation.itemList[i])
        }
      }
    },
    // カテゴリー検索（カテゴリー別）
    selectCat: function(catId, catName) {
      this.numberSearch = 999
      this.searchCat = catName
      let buttonCat = document.getElementsByClassName('category')
      let buttonSelectCat = document.getElementById(catName)
      for (let i = 0; i < buttonCat.length; i++) {
        buttonCat[i].classList.remove('active')
      }
      buttonSelectCat.classList.add('active')
      this.reservation.showItemList = []
      for (let i = 0; i < this.reservation.itemList.length; i++) {
        if (!this.reservation.itemList[i]) {
          this.seen = false
          return
        } else {
          this.seen = true
          const canDo = this.reservation.itemList[i].acf['製造可能店舗'].some(
            ({ post_title }) => post_title === this.radioResult
          )

          if (this.reservation.itemList[i]._embedded['wp:term'][0][0].name === catName && canDo) {
            this.reservation.showItemList.push(this.reservation.itemList[i])
          }
          if (this.reservation.showItemList.length === 999) {
            break
          } else {
            this.seen = false
          }
        }
      }
    },
    // もっとみる
    readMore: function() {
      this.numberSearch += 5
      this.reservation.showItemList = []
      if (this.searchCat === '') {
        for (let i = 0; i < this.numberSearch; i++) {
          if (!this.reservation.itemList[i]) {
            this.seen = false
            return
          }
          this.reservation.showItemList.push(this.reservation.itemList[i])
          if (!this.reservation.itemList[i + 1]) {
            this.seen = false
            return
          }
        }
      } else {
        for (let i = 0; i < this.reservation.itemList.length; i++) {
          if (!this.reservation.itemList[i]) {
            this.seen = false
            return
          }
          if (this.reservation.itemList[i]._embedded['wp:term'][0][0].name === this.searchCat) {
            this.reservation.showItemList.push(this.reservation.itemList[i])
          }
          if (!this.reservation.itemList[i + 1]) {
            this.seen = false
            return
          }
        }
      }
      if (this.reservation.showItemList.length < this.numberSearch) {
        this.seen = false
      }
    },
    // カートのポップアップ
    popUpCart: function() {
      if (this.step == 3) {
        let modalCart = document.getElementById('modalCart')
        modalCart.style.display = 'block'
      }
    },
    // 合計金額をApp.vueに返す
    returnAppSum: function(number) {
      this.$emit('setAppSum', this.reservation.sum, number)
    },
    // もっとみるボタンの表示・非表示
    checkSeen: function() {
      //        if (this.reservation.showItemList.length === 0 || this.reservation.itemList.length <= 999 || this.reservation.showItemList.length === this.reservation.itemList.length || this.reservation.showItemList.length <= this.numberSearch) {
      //          this.seen = false
      //        } else {
      //          this.seen = true
      //        }
      this.seen = false
    },
    // カートの表示・非表示
    showCart: function() {
      this.seenCart = true
      let cartMain = document.getElementsByClassName('step3--main')
    },
    hideCart: function() {
      if (this.reservation.cart.length === 0) {
        this.seenCart = false
        let cartMain = document.getElementsByClassName('step3--main')
      }
    },
    // カートのコンテンツの表示・非表示（ろうそく＋メッセージ）
    showCartContents: function(item) {
      if (
        item._embedded['wp:term'][0][0].name === 'ホールケーキ' ||
        item._embedded['wp:term'][0][0].name === '季節のイベントケーキ'
      ) {
        this.seenCartContents = true
      } else {
        this.seenCartContents = false
      }
    },
    // お客様情報の取得
    customer: function() {
      let name1 = document.getElementsByName('name1')
      let name3 = document.getElementsByName('name3')

      let name2 = document.getElementsByName('name2')
      let name4 = document.getElementsByName('name4')

      let tel = document.getElementsByName('tel')
      let email = document.getElementsByName('email')
      let contactTime = document.getElementById('contactTime')
      let dm = document.getElementsByName('dm')
      let payment_method = document.getElementsByName('payment_method')

      // 住所
      let add1 = document.getElementsByName('add1')
      // let add2 = document.getElementsByName('add2')
      // let add3 = document.getElementsByName('add3')
      let add4 = document.getElementsByName('add4')

      let comment = document.getElementsByName('comment')

      this.reservation.customer.name1 = name1[0].value + name3[0].value
      this.reservation.customer.sei = name1[0].value
      this.reservation.customer.mei = name3[0].value

      this.reservation.customer.name2 = name2[0].value + name4[0].value
      this.reservation.customer.kanasei = name2[0].value
      this.reservation.customer.kanamei = name4[0].value

      this.reservation.customer.tel = tel[0].value
      this.reservation.customer.email = email[0].value
      // 連絡のつきやすい時間帯
      this.reservation.customer.contactTime = contactTime.value
      // DMの値取得
      for (let i = 0; i < dm.length; i++) {
        if (dm[i].checked) {
          this.reservation.customer.dm = dm[i].value
          break
        }
      }
      // payment_methodの値取得
      for (let i = 0; i < payment_method.length; i++) {
        if (payment_method[i].checked) {
          this.reservation.customer.payment_method = payment_method[i].value
          break
        }
      }
      this.reservation.customer.add1 = add1[0].value
      this.reservation.customer.add2 = ''
      this.reservation.customer.add3 = ''
      this.reservation.customer.add4 = add4[0].value

      this.reservation.customer.comment = comment[0].value
      // フラグをtrueに(正規表現でチェック)
      let tel_replace = tel[0].value.replace(/[━.*‐.*―.*－.*\-.*ー.*\-]/gi, '')
      if (!name2[0].value.match(/^[ァ-ヶー　 ]*$/) || !name4[0].value.match(/^[ァ-ヶー　 ]*$/)) {
        alert('例のように正しくフリガナを入力してください。')
        this.reservation.flag2 = false
      } else if (!tel_replace.match(/^(0[5-9]0[0-9]{8}|0[1-9][1-9][0-9]{7})$/)) {
        alert('例のように正しく電話番号を入力してください。')
        this.reservation.flag2 = false
      } else {
        this.reservation.flag2 = true
      }
    },
    // トップボタンや戻るボタンを押した際にカートをリセット
    clear: function() {
      if (this.radioResult !== '') {
        this.radioResult = ''
        this.reservation.cart = []
        this.seenCart = false
        this.reservation.hiddenSum = 0
        this.reservation.tax = 0
        this.reservation.sum = 0
        this.reservation.count = 0
        this.reservation.showItemList = []
        this.reservation.itemList = []
        this.reservation.totalCartItemNumber = 0
      }
    }
  }
}
</script>

<style scoped lang="scss">
.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active for below version 2.1.8 */ {
  opacity: 0;
}
#reservation {
  font-family: 游明朝, 'Yu Mincho', YuMincho, 'Hiragino Mincho ProN', HGS明朝E, メイリオ, Meiryo, serif;
  background-color: #fdf5e6;
  padding-top: 70px;
  padding-bottom: 70px;
  .stepContent {
    padding-bottom: 40px;
    background-color: #fff;
    position: relative;
  }
}
.prev {
  margin-top: 30px;
  text-align: center;
  &:hover {
    opacity: 0.7;
    cursor: pointer;
  }
  i {
    margin-right: 5px;
  }
  span {
    border-bottom: 1px #000 solid;
  }
}
.topLink {
  color: #000;
  text-align: center;
  display: block;
  margin-top: 20px;
  &:hover {
    text-decoration: none;
    opacity: 0.7;
  }
  span {
    border-bottom: 1px #000 solid;
  }
}

.next-btn-loading {
  display: flex;
  justify-content: center;
  margin: 1rem;
}

.hidden_ {
  display: none;
}
</style>
